import React from 'react';
import { GetIdelinkStoreParams, IdelinkStore } from '../../IdelinkStore';
import { LogoFactory, LogoProps } from '../../../libs/IdeLink.Web.Common/src/components/Logo';
import { NAVBAR_C_LOCATION, NavBarFactory, NavBarProps } from '../../../libs/IdeLink.Web.Common/src/components/NavBar';
import {
	AUTH_BASE_C_LOCATION,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Pages/components/AuthBase/AuthBase';
import { StoreProvider } from '../../../libs/IdeLink.Web.Common/src/redux/StoreProvider';
import { AsyncPageLoading } from '../../../libs/IdeLink.Web.Common/src/scenes/AsyncPageLoading';
import { Loading } from '../../../libs/IdeLink.Web.Common/src/scenes/Loading';
import { AppWrapperBase } from './AppWrapperBase';
import {
	ApiConfig,
	ElasticSearchConfig,
	EnvironmentConfig,
	initApiConfig,
} from '../../../libs/IdeLink.Web.Common/src/configs/ApiConfig';

export type IdelinkAppWrapperProps = {
    importLocaleData?: () => Promise<any>;
    apiConfig?: ApiConfig;
    esLogsConfig?: ElasticSearchConfig;
    googleMapApiKeyConfig?: EnvironmentConfig;
    customNavbar?: React.FC<NavBarProps>;
    customLogo?: {
        default: React.FC<LogoProps>;
        loading?: React.FC<LogoProps>;
        auth?: React.FC<LogoProps>;
        nav?: React.FC<LogoProps>;
    };
} & GetIdelinkStoreParams;

export const IdelinkAppWrapper = ({
    children,
    authStorageKey,
    loginMethod,
    I18n,
    apiConfig,
    esLogsConfig,
    googleMapApiKeyConfig,
    customNavbar,
    customLogo,
}: React.PropsWithChildren<IdelinkAppWrapperProps>) => {
    initApiConfig(apiConfig, esLogsConfig, googleMapApiKeyConfig);

    if (customNavbar) {
        NavBarFactory.register('**', customNavbar);
    }

    if (customLogo) {
        if (customLogo.auth) {
            LogoFactory.register(`**/${AUTH_BASE_C_LOCATION}`, customLogo.auth);
        }

        if (customLogo.nav) {
            LogoFactory.register(`**/${NAVBAR_C_LOCATION}`, customLogo.nav);
        }

        if (customLogo.loading) {
            LogoFactory.register(
                [`**/${AsyncPageLoading.C_LOCATION}/`, `**/${Loading.C_LOCATION}`],
                customLogo.loading
            );
        }

        LogoFactory.register('**', customLogo.default);
    }

    const { store, persistor } = IdelinkStore.getStore({
        authStorageKey,
        loginMethod,
        I18n,
    });

    StoreProvider.getStore.register('**', () => store);

    return (
        <AppWrapperBase store={store} persistor={persistor}>
            {children}
        </AppWrapperBase>
    );
};
